import { IAuthDataSource } from '../../types/features/auth/auth-types';
import { appLoaderCommonDatasource } from './app-loader-common-datasource';

const authDatasource: IAuthDataSource = {
  logout: () => appLoaderCommonDatasource.logout(),
  login: data => appLoaderCommonDatasource.login(data),
  executeAuthCallback: data => appLoaderCommonDatasource.executeAuthCallback(data),
  getUsersMe: params => appLoaderCommonDatasource.getUsersMe(params),
  getProduct: host => appLoaderCommonDatasource.getProduct(host),
  temporarySignIn: data => appLoaderCommonDatasource.temporarySignIn(data),
  getShard: accountId => appLoaderCommonDatasource.getShard(accountId),
  refreshToken: () => appLoaderCommonDatasource.refreshToken(),
  getManifest: url => appLoaderCommonDatasource.getManifest(url),
  requestPhoneVerification: (params, retry) =>
    appLoaderCommonDatasource.requestPhoneVerification(params, retry),
  requestVerificationPrepare: params =>
    appLoaderCommonDatasource.requestVerificationPrepare(params),
  checkCodeByID: (id, token) => appLoaderCommonDatasource.checkCodeByID(id, token),
  checkPhoneCode: (registrationId, code, accessToken) =>
    appLoaderCommonDatasource.checkPhoneCode(registrationId, code, accessToken),
  register: data => appLoaderCommonDatasource.register(data),
  createWithAccount: (path, data, headers) =>
    appLoaderCommonDatasource.createWithAccount(path, data, headers),
  requestRecoveryEmail: data => appLoaderCommonDatasource.requestRecoveryEmail(data),
  resetPassword: data => appLoaderCommonDatasource.resetPassword(data),
  validateResetPasswordToken: token => appLoaderCommonDatasource.validateResetPasswordToken(token),
  validateInvitation: token => appLoaderCommonDatasource.validateInvitation(token),
  confirmInvitation: (token, data) => appLoaderCommonDatasource.confirmInvitation(token, data),
};

export { authDatasource };
